import { useRouteMatch } from '@appmaker/core/routes';

export default function useProject() {
    let { params } = useRouteMatch();

    const { projectId } = params;
    return { projectId }
}